import { all, fork } from "redux-saga/effects";
import { createRequest } from "../utils";
import { invoicesActions } from ".";
import api from "../../utils/api";

const getInvoicesRequest = createRequest(
  invoicesActions.GET_INVOICES,
  api.get,
  (action) => {
    const { from = 0, limit = 50, accountId = "", kind = "", govStatus = "", emailStatus = "" } = action.payload;
    return {
      url: `/invoices?from=${from}&limit=${limit}&account_id=${accountId}&kind=${kind}&gov_status=${govStatus}&email_status=${emailStatus}`,
    };
  }
);

const getChargebeeInvoicesRequest = createRequest(
  invoicesActions.GET_CHARGEBEE_INVOICES,
  api.get,
  (action) => {
    const { accountId = "", limit = 50 } = action.payload;
    return {
      url: `/invoices/chargebee?account_id=${accountId}&limit=${limit}`,
    };
  }
);

const getChargebeeCreditNotesRequest = createRequest(
  invoicesActions.GET_CHARGEBEE_CREDIT_NOTES,
  api.get,
  (action) => {
    const { accountId = "", limit = 50 } = action.payload;
    return {
      url: `/credit-notes/chargebee?account_id=${accountId}&limit=${limit}`,
    };
  }
);

const triggerActionsRequest = createRequest(
  invoicesActions.TRIGGER_ACTIONS,
  api.post,
  (action) => {
    const { invoiceId, actions } = action.payload;
    return {
      url: `/invoices/${invoiceId}/trigger`,
      body: JSON.stringify({ actions }),
    };
  }
);

const triggerCreditNoteActionsRequest = createRequest(
  invoicesActions.TRIGGER_CREDIT_NOTE_ACTIONS,
  api.post,
  (action) => {
    const { creditNoteId, actions } = action.payload;
    return {
      url: `/credit-notes/${creditNoteId}/trigger`,
      body: JSON.stringify({ actions }),
    };
  }
);

export default function* rootSaga() {
  yield all([
    fork(getInvoicesRequest),
    fork(getChargebeeInvoicesRequest),
    fork(getChargebeeCreditNotesRequest),
    fork(triggerActionsRequest),
    fork(triggerCreditNoteActionsRequest),
  ]);
}